import { DOCUMENT } from '@angular/common';
import { computed, FactoryProvider, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { EnvironmentStore } from '@nx-vigil/core/web/environment/data-access';
import { CORE_PROFILE_PORTAL_URL } from '@nx-vigil/core/web/shell/ui';

export const PRODUCT_PORTAL_FEATURE = 'product-portal';

export const provideProductPortal = (): FactoryProvider => ({
  provide: CORE_PROFILE_PORTAL_URL,
  useFactory: () => {
    const portalUrl = getProductPortalUrl(inject(DOCUMENT).location);
    const isEnabled = toSignal(
      inject(EnvironmentStore).getFeature$(PRODUCT_PORTAL_FEATURE),
      { initialValue: false },
    );
    return computed(() => (isEnabled() ? portalUrl : undefined));
  },
});

export function getProductPortalUrl({
  protocol,
  hostname,
}: Pick<Location, 'protocol' | 'hostname'>): string | undefined {
  const isIpAddress = /^[\d.]+$/.test(hostname);
  const [, ...parentLabels] = hostname.split('.');
  if (isIpAddress || parentLabels.length < 2) {
    return undefined;
  }

  return `${protocol}//${parentLabels.join('.')}`;
}
